// Simplified Chinese — 完整镜像 zh-Hant，供中国大陆买家。
// 字符转为简体，部分词汇采用大陆惯用说法（如「目录」「参观」「定制」）。

const common = {
  // Navigation
  "nav.home": "首页",
  "nav.products": "产品",
  "nav.factory": "工厂",
  "nav.about": "关于我们",
  "nav.contact": "联系我们",
  "nav.requestQuote": "询价报价",
  "nav.menu": "菜单",
  "nav.language": "语言",

  // CTAs
  "cta.requestQuote": "立即询价",
  "cta.exploreCatalog": "浏览目录",
  "cta.contactUs": "联系我们",
  "cta.scheduleFactoryVisit": "预约参观工厂",
  "cta.requestSample": "索取样品",
  "cta.viewAll": "浏览全部产品",

  // Common
  "common.tbd": "[待 Forwaro 确认]",
  "common.category": "分类",
  "common.material": "材质",
  "common.style": "风格",
  "common.filters": "筛选",
  "common.resetAll": "重置",
  "common.details": "详情",

  // Brand
  "brand.name": "风华国际",
  "brand.chineseName": "风华国际",
  "brand.tagline": "FORWARO FURNITURE · 风华国际 · 现代家具",

  "whatsapp.cta": "在 WhatsApp 联系我们",
  "wechat.cta": "加我们的微信",


  // Home · Hero
  "home.hero.badge": "FORWARO · 风华国际 · 现代家具",
  "home.hero.headline.line1": "家，是忙碌生活中",
  "home.hero.headline.line2Highlight": "一切的中心。",
  "home.hero.headline.line3": "",
  "home.hero.subheadline": "Forwaro Furniture 风华国际 是一家位于东莞的 OEM / ODM 制造商，以家具设计搭配稳定的生产品质，服务中东、欧洲、美洲与亚洲的进口商。",
  "home.hero.stat1.value": "6",
  "home.hero.stat1.label": "产品线",
  "home.hero.stat2.value": "OEM / ODM",
  "home.hero.stat2.label": "定制化生产",
  "home.hero.stat3.value": "东莞",
  "home.hero.stat3.label": "民田工业区",
  "home.hero.stat4.value": "全球",
  "home.hero.stat4.label": "出口合作网络",
  "home.hero.scroll": "下滑",

  // Home · Categories
  "home.categories.kicker": "产品分类",
  "home.categories.heading": "六大产品线，一家值得信赖的工厂",
  "home.categories.description": "餐桌、茶几、玄关桌、椅子、沙发与电视柜：Forwaro 专为出口生产的六大 B2B 家具产品线。",

  // Home · About
  "home.about.kicker": "关于 Forwaro",
  "home.about.heading.line1": "家具设计，",
  "home.about.heading.line2": "一贯的工艺坚持。",
  "home.about.philosophy.en":
    "在日益繁忙的生活里，家是一切的中心。生活美学相对成为成功人士对家的追求与品味。风华国际秉持一贯对家具的设计理念，与生产品质的坚持，希望为所有的家，提升至美学与工艺相辅的层次空间。",
  "home.about.location": "Forwaro Furniture（风华国际有限公司）1991 年创立于台湾，2006 年起于中国大陆设厂制造，目前运营据点位于东莞沙田镇民田工业区。Forwaro 与重视诚实工艺、可靠交期的进口商并肩合作。",
  "home.about.highlight1.title": "OEM 与 ODM",
  "home.about.highlight1.body": "从自有品牌代工到完整设计与结构定制化，皆可配合。",
  "home.about.highlight2.title": "出口级品管",
  "home.about.highlight2.body": "木工、表面处理、包装逐站检查，并考量长程海运的耐运表现。",
  "home.about.highlight3.title": "天然大理石与钢材",
  "home.about.highlight3.body": "招牌天然大理石桌面，搭配电镀不锈钢与铁制底座。",
  "home.about.highlight4.title": "全球出口网络",
  "home.about.highlight4.body": "自东莞出发，服务中东、欧洲、美洲与亚洲的进口商。",
  "home.about.badgeLocation": "中国・东莞",
  "home.about.badgeZone": "民田工业区",
  "home.about.badgeOem": "OEM /\nODM",
  "home.about.badgeOemSub": "定制化与自有品牌",

  // Home · Featured Products
  "home.featured.kicker": "目录预览",
  "home.featured.heading": "抢先预览 Forwaro 六大产品线",
  "home.featured.description": "真实的 Forwaro 型号，材质与尺寸均经确认。欢迎联系我们索取完整规格与报价。",

  // Home · Markets
  "home.markets.kicker": "全球版图",
  "home.markets.heading": "我们服务的出口市场",
  "home.markets.description":
    "Forwaro 与四大洲的家具进口商、经销商、酒店集团与住宅项目合作。",

  // Home · Process
  "home.process.heading": "合作流程",
  "home.process.description": "从第一次询价到货柜上船 — Forwaro 标准出口流程",

  // Footer
  "footer.getInTouch.kicker": "联系我们",
  "footer.getInTouch.heading": "与 Forwaro 一起\n开启家具进口合作",
  "footer.getInTouch.description":
    "我们的出口团队可为您提供定制报价、样品寄送与完整出口文件支持。",
  "footer.contact.email": "电子邮件",
  "footer.contact.phone": "电话",
  "footer.contact.fax": "传真",
  "footer.contact.factory": "工厂",
  "footer.contact.whatsappNote": "WhatsApp / WeChat 账号待 Forwaro 确认后补上。",
  "footer.form.heading": "立即询价",
  "footer.form.name": "姓名",
  "footer.form.email": "电子邮件",
  "footer.form.company": "公司",
  "footer.form.country": "国家",
  "footer.form.countryPlaceholder": "请选择国家",
  "footer.form.message": "留言",
  "footer.form.messagePlaceholder": "请告诉我们您的需求、预计数量与目标市场…",
  "footer.form.submit": "提交询价",
  "footer.form.sending": "提交中…",
  "footer.form.success.heading": "已提交！",
  "footer.form.success.body": "出口团队将于两个工作日内与您联系。",
  "footer.form.sendAnother": "再发一次",
  "footer.footerTagline": "Forwaro Furniture · 风华国际 · 现代家具。位于东莞的 OEM/ODM 制造商，服务中东、欧洲、美洲与亚洲的进口商。",
  "footer.col.products": "产品",
  "footer.col.company": "公司",
  "footer.col.markets": "出口市场",
  "footer.col.regional": "想成为区域经销商？",
  "footer.copyright": "版权所有。",
};

export default common;
